// Artwork exported from the Figma section "01 · Entry point" (4488:19598) on the PAVEL DRAFT
// page, via the Dev Mode asset server. The badges come from the "Achievement / Badge" master
// (4387:42725), which ships a locked and an unlocked bitmap per tier: the file's note is
// "Locked = greyscale + darkened via image filters", so the two tones are separate images rather
// than one image the app could tint.
//
// The SVGs ship without root width/height on purpose: @svgr/webpack strips `viewBox` from any SVG
// whose width/height equal it, and every icon here is drawn at a scaled size - see the note in
// InventoryTabs and the web build's nav icons.
import BadgeTier1Png from './badge-tier-1.png';
import BadgeTier1LockedPng from './badge-tier-1-locked.png';
import BadgeTier2Png from './badge-tier-2.png';
import BadgeTier2LockedPng from './badge-tier-2-locked.png';
import BadgeTier3Png from './badge-tier-3.png';
import BadgeTier3LockedPng from './badge-tier-3-locked.png';
import BadgeTier4Png from './badge-tier-4.png';
import BadgeTier4LockedPng from './badge-tier-4-locked.png';
import BadgeTier5Png from './badge-tier-5.png';
import BadgeTier5LockedPng from './badge-tier-5-locked.png';
import EmptyBadgePng from './empty-badge.png';
import EmptySlotPng from './empty-slot.png';
import IconBackSvg from './icon-back.svg';
import IconChevronDownSvg from './icon-chevron-down.svg';
import IconCloseSvg from './icon-close.svg';
import IconCloseSmallSvg from './icon-close-small.svg';
import IconRemoveSvg from './icon-remove.svg';
import IndicatorAddSvg from './indicator-add.svg';
import IndicatorCheckSvg from './indicator-check.svg';
import IndicatorLockSvg from './indicator-lock.svg';
import IndicatorRemoveSvg from './indicator-remove.svg';
import MilestoneCurrentSvg from './milestone-current.svg';

/** Indexed by tier 1..5, the way the badge master's `tier` property is. */
export const BadgeArtwork = {
	unlocked: [BadgeTier1Png, BadgeTier2Png, BadgeTier3Png, BadgeTier4Png, BadgeTier5Png] as const,
	locked: [
		BadgeTier1LockedPng,
		BadgeTier2LockedPng,
		BadgeTier3LockedPng,
		BadgeTier4LockedPng,
		BadgeTier5LockedPng,
	] as const,
};

export {
	BadgeTier1LockedPng,
	BadgeTier1Png,
	BadgeTier2LockedPng,
	BadgeTier2Png,
	BadgeTier3LockedPng,
	BadgeTier3Png,
	BadgeTier4LockedPng,
	BadgeTier4Png,
	BadgeTier5LockedPng,
	BadgeTier5Png,
	EmptyBadgePng,
	EmptySlotPng,
	IconBackSvg,
	IconChevronDownSvg,
	IconCloseSmallSvg,
	IconCloseSvg,
	IconRemoveSvg,
	IndicatorAddSvg,
	IndicatorCheckSvg,
	IndicatorLockSvg,
	IndicatorRemoveSvg,
	MilestoneCurrentSvg,
};
